import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar } from '../../../../common/components/Avatar'
import Button from '../../../../common/components/Button'
import Content from '../../../../common/components/Content'
import Form, {
  FormFieldset,
  FormError,
  FormHeader,
  FormikFormInput as FormInput,
  FormInputLabel
} from '../../../../common/components/Form'
import Hr from '../../../../common/components/Hr'
import Row, { RowSpacer } from '../../../../common/components/Row'
import Text, { Paragraph } from '../../../../common/components/Text'
import history from '../../../../Root/history'
import ChangePassword from './ChangePassword'
import ReauthModal from './ReauthModal'
import UserHeader from './UserHeader'
import Card, { CardHeader } from '../../../../common/components/Card'
import Icon from 'common/components/Icon'
import Label from 'common/components/Label'

const usePreventNavigation = prevent => {
  const { t } = useTranslation()
  useEffect(() => {
    if (prevent) {
      const beforeunload = e => {
        e.preventDefault() // Cancel the event
        e.returnValue = '' // Chrome requires returnValue to be set
      }
      window.addEventListener('beforeunload', beforeunload)
      const unblock = history.block(() => {
        return window.confirm(t('settings.confirmLeave'))
      })
      return () => {
        window.removeEventListener('beforeunload', beforeunload)
        unblock()
      }
    }
  }, [prevent])
}

const Account = ({
  user,
  handleSubmit,
  values,
  submitForm,
  resetForm,
  dirty,
  isValid,
  errors,
  isSubmitting,
  smallScreen
}) => {
  const { t } = useTranslation()
  const provider = user.providerData[0].providerId

  usePreventNavigation(dirty)

  return (
    <>
      {errors.email === 'settings.errors.requiresRecentLogin' && (
        <ReauthModal
          close={resetForm}
          email={user.email}
          submitForm={submitForm}
        />
      )}

      <Row z>
        {smallScreen && (
          <>
            <Button to="/settings">
              <Icon icon="menu" />
            </Button>
            <Label>{t('settings.account')}</Label>
          </>
        )}
        <RowSpacer />
        <Button
          onClick={submitForm}
          disabled={!dirty || !isValid}
          primary={dirty}
        >
          {t(
            isSubmitting
              ? 'settings.saving'
              : dirty
              ? 'settings.save'
              : 'settings.saved'
          )}
        </Button>
      </Row>
      <Content scroll>
        <Form onSubmit={handleSubmit}>
          <UserHeader>
            <Avatar large name={values.displayName || user.displayName} />
            <Text bold>{values.displayName || user.displayName}</Text>
          </UserHeader>
          <Hr />
          {provider === 'google.com' && (
            <>
              <Card>
                <CardHeader>
                  <Text bold>{t('settings.google.title')}</Text>
                </CardHeader>
                <Paragraph grey>{t('settings.google.description')}</Paragraph>
                <Button
                  medium
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://myaccount.google.com/signinoptions/password"
                >
                  {t('settings.google.changePassword')}
                </Button>
              </Card>
              <Hr />
            </>
          )}
          <FormHeader>{t('settings.information')}</FormHeader>

          <FormFieldset>
            <FormInputLabel>{t('settings.name')}</FormInputLabel>
            <FormInput invalid={errors.displayName} name="displayName" />
            <FormError name="displayName" />
          </FormFieldset>

          {provider === 'google.com' ? (
            <FormFieldset>
              <FormInputLabel>{t('settings.email')}</FormInputLabel>
              <FormInput name="email" disabled />
            </FormFieldset>
          ) : (
            <>
              <FormFieldset>
                <FormInputLabel>{t('settings.email')}</FormInputLabel>
                <FormInput invalid={errors.email} name="email" type="email" />
                <FormError name="email" />
              </FormFieldset>

              <Hr />
              <ChangePassword email={user.email} />
            </>
          )}
          <button hidden />
        </Form>
      </Content>
    </>
  )
}

export default Account
